import { render, staticRenderFns } from "./SallyTextEditor.vue?vue&type=template&id=bf7ad7aa&scoped=true"
import script from "./SallyTextEditor.vue?vue&type=script&lang=js"
export * from "./SallyTextEditor.vue?vue&type=script&lang=js"
import style0 from "./SallyTextEditor.vue?vue&type=style&index=0&id=bf7ad7aa&prod&lang=scss&scoped=true"
import style1 from "./SallyTextEditor.vue?vue&type=style&index=1&id=bf7ad7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ad7aa",
  null
  
)

export default component.exports